const resolvers = {
    Query: {
        currentUserUploads() {
            return {
                ok: true,
                errors: [],
                photos: {
                    pendingCount: 4132,
                    deniedCount: 36543,
                    hasApprovedUploads: false,
                    __typename: "UserUploads"
                },
                icons: {
                    pendingCount: 0,
                    deniedCount: 0,
                    hasApprovedUploads: false,
                    __typename: "UserUploads"
                },
                __typename: "UserUploadsResponse"
            };
        }
    }
};

export default resolvers;
